export const truncateString = (value: string, maxLength: number = 20, options?: { suffix?: string }): string => {
  const str = String(value);
  const suffix = options?.suffix ?? "...";

  if (str.length <= maxLength) return str;
  return str.slice(0, maxLength) + suffix;
};

export async function setTimeoutAsync(timeout: number): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    setTimeout(resolve, timeout);
  });
}
